var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45215 23.6933L11.2344 16.1289",
    stroke: "#8CA1B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83105 5.32252L9.07294 1",
    stroke: "#8CA1B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83105 5.32284L10.6939 8.02441",
    stroke: "#8CA1B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.235 16.1282L16.3665 14.5697",
    stroke: "#8CA1B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8361 4.35914L12.6955 5.34921L12.8361 4.35914ZM18.9509 7.15868L18.2933 7.91203V7.91203L18.9509 7.15868ZM22.5507 12.8393L23.5127 12.5663V12.5663L22.5507 12.8393ZM22.4715 19.564L21.5162 19.2684V19.2684L22.4715 19.564ZM18.7388 25.1583L19.3785 25.9269H19.3785L18.7388 25.1583ZM5.93242 26.6696L5.48924 27.5661H5.48924L5.93242 26.6696ZM1.86025 21.5881C1.57865 21.113 0.96523 20.9562 0.490127 21.2378C0.0150244 21.5194 -0.141845 22.1328 0.13975 22.6079L1.86025 21.5881ZM6.60562 6.2526C8.50538 5.36847 10.6209 5.05465 12.6955 5.34921L12.9767 3.36907C10.5188 3.02009 8.01247 3.39189 5.76175 4.43935L6.60562 6.2526ZM12.6955 5.34921C14.7701 5.64376 16.7147 6.53404 18.2933 7.91203L19.6085 6.40533C17.7383 4.77278 15.4345 3.71804 12.9767 3.36907L12.6955 5.34921ZM18.2933 7.91203C19.8719 9.29002 21.0166 11.0965 21.5887 13.1123L23.5127 12.5663C22.835 10.1781 21.4787 8.03788 19.6085 6.40533L18.2933 7.91203ZM21.5887 13.1123C22.1608 15.1281 22.1356 17.2667 21.5162 19.2684L23.4268 19.8596C24.1606 17.4881 24.1905 14.9545 23.5127 12.5663L21.5887 13.1123ZM21.5162 19.2684C20.8967 21.2702 19.7097 23.0492 18.0991 24.3896L19.3785 25.9269C21.2866 24.3389 22.6929 22.2312 23.4268 19.8596L21.5162 19.2684ZM18.0991 24.3896C16.4885 25.73 14.5235 26.5742 12.4425 26.8198L12.6769 28.806C15.1423 28.5151 17.4703 27.5149 19.3785 25.9269L18.0991 24.3896ZM12.4425 26.8198C10.3615 27.0654 8.254 26.7018 6.3756 25.7732L5.48924 27.5661C7.71465 28.6663 10.2115 29.097 12.6769 28.806L12.4425 26.8198ZM6.3756 25.7732C4.4972 24.8445 2.92865 23.3907 1.86025 21.5881L0.13975 22.6079C1.40552 24.7435 3.26383 26.4658 5.48924 27.5661L6.3756 25.7732Z",
    fill: "#8CA1B4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2342,
    cy: 16.1288,
    r: 1.62094,
    fill: "#8CA1B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredTimer);
export default __webpack_public_path__ + "static/media/expired-timer.e7fd6fc97adb447f10b40f0d1be703be.svg";
export { ForwardRef as ReactComponent };